// AUTO-GENERATED by scripts/inject-build-info.js — do not edit manually
export const BUILD_INFO = {
  commitHash: 'dev',
  buildTime: '2026-11-02T21:11:23.933Z',
} as const;
